<div *ngIf="mapHasAPI; else imageMap">
	<p>Error: dynamic map has not been implemented.</p>
</div>

<ng-template #imageMap>
	<img src="{{ mapImageLink }}" alt="coloredMap" />
</ng-template>
